import React from 'react';
import ListK4 from '../../components/spravochniki/k4/ListK4'

function Page(props) {
    return (
        <>
          <ListK4 />
        </>
    );
}

export default Page;